import React from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { guest_user } from "../helpers";

const DashboardSideBar = ({ navigate, setUser, currentPage }) => {
  return (
    <div className="col-lg-3 py-8 my-16 DashboardSideBar">
      <div className="list-group shadow bg-white py-18 border rounded-top-3">
        <Link
          to="/dashboard"
          className={
            currentPage == "My Profile"
              ? "white-image-sidebar-dashboard list-group-item active list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn rounded-0 border-bottom-0"
              : "list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn rounded-0 border-bottom-0 border-top-0 dashboard-sidebar-list-item"
          }
          aria-current="true"
        >
          <span className="icon text-xl d-flex">
            <img src="assets\images\icon\layer.png" className="layers" />
          </span>
          My Profile
        </Link>

        <Link
          to="/my-order"
          className={
            currentPage == "My Order"
              ? "white-image-sidebar-dashboard list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn border-bottom-0 active"
              : "list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn border-bottom-0 dashboard-sidebar-list-item"
          }
          aria-current="true"
        >
          <span className="icon text-xl d-flex">
            <img
              src="assets\images\icon\storefront.png"
              alt=""
              className="layers"
            />
          </span>
          My Order
        </Link>
        <Link
          to="/address"
          className={
            currentPage == "address"
              ? "white-image-sidebar-dashboard list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn border-bottom-0 active"
              : "list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn border-bottom-0 dashboard-sidebar-list-item"
          }
          aria-current="true"
        >
          <span className="icon text-xl d-flex">
            <img src="assets\images\icon\book.png" alt="" className="layers" />
          </span>
          Address
        </Link>
        <button
          onClick={() => {
            toast.success("User Logged Out Successfully!");
            setUser(guest_user);

            setTimeout(() => {
              window.location.pathname = "/";
            }, 300);
          }}
          to="/login"
          className="list-group-item list-group-item-action d-inline-flex align-items-center gap-14 dashboard-btn border-bottom-0 dashboard-sidebar-list-item rounded-0"
          aria-current="true"
        >
          <span className="icon text-xl d-flex">
            <img
              src="assets\images\icon\logout.png"
              alt=""
              className="layers"
            />
          </span>
          Logout
        </button>
      </div>
    </div>
  );
};

export default DashboardSideBar;
